import React, { useContext, useState } from 'react';
import { authContext } from '../../../context/AuthContext';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import Collapse from '@mui/material/Collapse';
import ButtonBase from '@mui/material/ButtonBase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AMAZON_CSV_FIELDS = [
    { header: 'Order ID', purpose: 'Invoice / order number' },
    { header: 'Order Date', purpose: 'Invoice date' },
    { header: 'ASIN', purpose: 'Item identifier (matched to catalog)' },
    { header: 'Title', purpose: 'Item name' },
    { header: 'Item Quantity', purpose: 'Quantity purchased' },
    { header: 'Item Net Total', purpose: 'Line item cost' },
    { header: 'Item Tax', purpose: 'Tax amount' },
    { header: 'Item Shipping & Handling', purpose: 'Shipping amount' },
    { header: 'Amazon-Internal Product Category', purpose: 'Category (optional fallback)' },
];

export default function ImportCSVFile({ vendorSel }) {
    const { userRole } = useContext(authContext)
    const [schemaOpen, setSchemaOpen] = useState(false)

    let vendorCsv
    userRole === "AppAdmin" ?
        vendorCsv = ["Amazon"] :
        vendorCsv = ["Amazon"]
    return (
        <>
            <div className='row' style={{ marginTop: '5px', marginBottom: '10px' }}>
                <div className='col-6'>
                    <Autocomplete
                        size="small"
                        options={vendorCsv}
                        onChange={(e, val) => vendorSel(val, "VendorName")}
                        sx={{ width: "200px", '.MuiInputBase-root': { height: '38px' } }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Vendor"
                            />
                        )}>
                        {vendorCsv.map((val, ind) =>
                            <MenuItem key={ind} value={val}>{val}</MenuItem>
                        )}
                    </Autocomplete>
                </div>
                <div className='col-6'>
                    <TextField
                        size='small'
                        sx={{ '.MuiInputBase-root': { height: '38px' } }}
                        label="Invoice Number / Order ID"
                        onChange={(e) => vendorSel(e.target.value, "InvoiceNum")}
                    />
                </div>
            </div>

            <div style={{ marginBottom: '15px' }}>
                <ButtonBase
                    onClick={() => setSchemaOpen((open) => !open)}
                    aria-expanded={schemaOpen}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        color: 'text.secondary',
                        fontSize: '13px',
                        fontWeight: 600,
                        py: 0.5,
                        px: 0.5,
                        borderRadius: 1,
                    }}
                >
                    Required CSV columns
                    <ExpandMoreIcon
                        fontSize="small"
                        sx={{
                            transform: schemaOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease',
                        }}
                    />
                </ButtonBase>
                <Collapse in={schemaOpen} timeout="auto" unmountOnExit>
                    <div
                        style={{
                            marginTop: '8px',
                            padding: '12px 14px',
                            border: '1px solid #D8DDD4',
                            borderRadius: '8px',
                            background: '#FFFEFB',
                        }}
                    >
                        <p style={{ margin: '0 0 8px', fontSize: '12px', color: '#6B6258' }}>
                            Header names must match exactly (Amazon export format):
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', color: '#2C241B' }}>
                            {AMAZON_CSV_FIELDS.map(({ header, purpose }) => (
                                <li key={header} style={{ marginBottom: '4px' }}>
                                    <code style={{ fontSize: '11px' }}>{header}</code>
                                    <span style={{ color: '#6B6258' }}> — {purpose}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Collapse>
            </div>
        </>
    );
};
